import { render, staticRenderFns } from "./ModalCheckout.vue?vue&type=template&id=0a5a6a82"
import script from "./ModalCheckout.vue?vue&type=script&lang=js"
export * from "./ModalCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports